import React from 'react';
import RenderDashboard from '../../../../../components/RenderDashboard';


//Renders the Dashboard based upon tab value;
const RenderAccountingDashboardContent = ({ value }) => {
  if (value === 'expense-dashboard') {
    return <RenderDashboard key={'accounting_expenses'} type={'accounting_expenses'}/>;
  }
  return <RenderDashboard key={'accounting'} type={'accounting'}/>;

};

export default RenderAccountingDashboardContent;
